import { Route, Routes, Navigate } from 'react-router'
import DevToolsLayout from './DevToolsLayout/DevToolsLayout'
import ContactsPage from './Contacts/ContactsPage'
import { Placeholder } from '@/containers/DevToolsNew/DevToolsLayout/styled-components'
import { useTranslation } from 'react-i18next'
import PodUpdaterPage from '@/containers/DevToolsNew/PodUpdater/PodUpdaterPage'

const BASE_PATH = '/dev-tools-v2'
const DevToolsNew = () => {
  const { t } = useTranslation('devToolsNew')
  return (
    <DevToolsLayout>
      <Routes>
        <Route index element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="pod-updater" element={<PodUpdaterPage />} />
        <Route path="feedback" element={<Placeholder>{t('common.routes.feedback')}</Placeholder>} />
        <Route path="commands" element={<Placeholder>{t('common.routes.commands')}</Placeholder>} />
        <Route path="cache" element={<Placeholder>{t('common.routes.cache')}</Placeholder>} />
        <Route path="*" element={<Navigate to={`${BASE_PATH}/contacts`} replace />} />
      </Routes>
    </DevToolsLayout>
  )
}

export default DevToolsNew
